var template = require('../templates/printTemplate.html');
/**
*  Module
*directives.paymentstatus
* Description
*/

var app = angular.module('directives.paymentstatus');

    app.directive('printtemplate', [
        '$rootScope',
        function () {
            var localeIndex       = 'menutitles',
                localeName        = 'ptint_template',
                predictionIndex   = 'docs';


            /**
             * returns date in dd.mm.yy format
             * @method parseDate
             * @param {String} date
             * @returns {String}
             */
            var parseDate = function (date) {
                var parsedDate = new Date(Date.parse(date));
                return $.datepicker.formatDate('dd.mm.yy', parsedDate) + ' ' +
                    parsedDate.getHours() + ':' + (parsedDate.getMinutes() < 10 ? '0' : '') +
                    parsedDate.getMinutes();
            };

            var disablePrediction = function (scope) {
                scope.printMenu    = false;
                scope.details      = null;
                scope.allowPrint   = false;
                scope.printItems   = [];
                scope.initTemplate = null;
            };

            var setPrintData = function (template, name, data) {
                data.push({name: name, template: template});
                return data;
            };

            var setPrintEvent = function (data, scope) {
                for (key in data) {
                  scope.printItems.push({template: data[key].template, name: data[key].name});
                }
                scope.printMenu = true;
            };
            var localizeObject = function (Localization) {
                return Localization.getLocalizedString(localeIndex, localeName);
            };

            var localeParse = function (data, printData, scope) {
                for (key in printData) {
                    if (data[printData[key].name]) {
                        printData[key].name = data[printData[key].name];
                    }
                };
                setPrintEvent(printData, scope);
            };

            var localizeContext = function (Localization, printData, scope) {
                var localeObject = localizeObject(Localization);
                for (key in localeObject) {
                  if (typeof(localeObject) == 'object' && localeObject[key] == 'then') {
                    localeObject.then(function (data) {
                        if (data.data[localeIndex] && (data.data[localeIndex].length || Object.keys(data.data[localeIndex]).length)) {
                            return localeParse(data.data[localeIndex], printData, scope);
                        }
                    });
                  } else {
                      return localeParse(localeObject, printData, scope);
                  }
                };
            };

            var verifyTemplate = function (printData, details, params, Localization) {
                params.scope.preloader  = false;
                /* case there's additional template, add it in context menu */
                if (details.data.additional_template) {

                    printData = setPrintData(
                        details.data.additional_template, 'additional', printData
                    );
                    if (params.scope.prediction) {
                        params.scope.initTemplate = details.data.additional_template;
                    }
                }

                /* case there's a prediction with template, set as initial, add to
                 * context menu, in case, only menu is not empty */
                if (params.scope.prediction && details.data.prediction_template) {
                    printData = setPrintData(
                        details.data.prediction_template, predictionIndex, printData
                    );
                    params.scope.initTemplate = details.data.prediction_template;
                }
                /* case basket post payment or any other section */
                if (details.data.template && !params.scope.prediction) {
                    /* case there's NO prediction use default template
                     * add template to context menu, only, in case menu is not empty  */
                    params.scope.initTemplate = details.data.template;
                    printData = setPrintData(
                        details.data.template, 'paybill', printData
                    );
                }

                if (!printData.length && !params.scope.initTemplate) {
                    /* template ist is empty, return */
                    params.scope.preloader  = false;
                    return false;
                }

                if (printData.length > 0) {
                    localizeContext(Localization, printData, params.scope);
                }
                /*if (params.scope.initTemplate) {
                    params.scope.allowPrint = true;
                    if (!params.scope.haltprint) {
                         params.scope.setPrintTemplate(params.scope, params.scope.initTemplate);
                    }
                }*/
                return true;
            };

            return {
                replace: true,
                restrict: 'EA',
                scope: {
                    callback:       '=',
                    callbackparams: '=',
                    data:           '=',
                    prediction:     '=',
                    datacontroller: '=',
                    card: '=',
                    haltprint: '=',
                    payment: '='
                },
                template: template,
                controller: [
                    '$scope',
                    '$rootScope',
                    '$compile',
                    '$timeout',
                    '$window',
                    function ($scope, $rootScope, $compile, $timeout, $window) {

                        var selectedCard      = null,
                            cardTypes         = {V: 'card', CASH : 'cash', def: 'card'},
                            currentCards      = [];
                        $scope.cardType       = null;
                        $scope.allowPrint     = false;
                        $scope.printMenu      = false;
                        $scope.preloader      = false;
                        $scope.printItems     = [$scope.payment];
                        $scope.printItemsData = {};
                        $scope.initTemplate   = null;

                        /**
                         * click trigger on template menu
                         * @param template
                         */

                        $scope.test = function () {


                        };
                        $scope.printItemClick = function (template) {


                            var objBrowse = $window.navigator;

                            if (objBrowse.appName === 'Opera') {
                                $scope.windowPrint = $window.open('', '_blank',
                                    'width=800,height=600,resizable=yes,scrollbars=yes,status=yes');
                            } else {
                                $scope.windowPrint = $window.open('', '_blank');
                            }

                            $scope.windowPrint.document.write(
                                '<html><body id="body">Loading...</body></html>'
                            );

                            if (template) {
                                $scope.setPrintTemplate($scope, template);
                            } else {
                                var watcher = $scope.$watch('payment', function(newValue) {
                                    if (newValue) {
                                        $scope.setPrintTemplate($scope, newValue.template);
                                        watcher();
                                    }
                                })
                            }
                        };

                        /**
                         * gets the selected card type
                         * sets the right selected card type format fo the payment data request
                         * works with cardId as $scope.callbackparams.id
                         * works with $scope.datacontroller and $scope.datacontroller.selectedPayments
                         * as the selected card holder
                         */
                        $timeout(function () {
                            if ($scope.callbackparams &&
                                $scope.callbackparams.id &&
                                $scope.datacontroller &&
                                $scope.datacontroller.selectedPayments
                                ) {
                                selectedCard = $scope.datacontroller.selectedPayments[$scope.callbackparams.id];
                                if (selectedCard && selectedCard.card && selectedCard.card.type) {
                                    $scope.$watch('datacontroller.selectedPayments[' +
                                        $scope.callbackparams.id + '].card.type',
                                        function (type) {
                                            $scope.cardType = (cardTypes[type]) ?
                                                cardTypes[type] :
                                                cardTypes.def;
                                            if (currentCards[$scope.callbackparams.id] &&
                                                currentCards[$scope.callbackparams.id] !== $scope.cardType
                                                ) {
                                                disablePrediction($scope);
                                                currentCards[$scope.callbackparams.id] = $scope.cardType;
                                            } else {
                                                currentCards[$scope.callbackparams.id] = $scope.cardType;
                                            }
                                        });
                                }
                            }
                        });

                        /**
                         * Sets and compiles print template, then open it into popup
                         * @method setPrintTemplate
                         * @param {Object} details Data details
                         * @param {Object} scope
                         * @param {String} template
                         */
                        $scope.setPrintTemplate = function (scope, template) {
                            var printTemplate = null;
                            var templ = $scope.payment;
                            scope.details = templ;
                                printTemplate = scope.details.template;

                            if (printTemplate) {
                                var clonedElement = $compile(printTemplate)
                                (
                                    scope,
                                    function (clonedElement) {
                                        $timeout(function () {
                                            $scope.windowPrint.document.getElementById("body").innerHTML = clonedElement.html();

                                            $scope.windowPrint.document.close();
                                            $scope.windowPrint.focus();
                                            $timeout(function () {
                                                $scope.windowPrint.print();
                                            }, 500);
                                        }, 500);
                                    }
                                );
                            } else {
                                $rootScope.Base.showError('print status error', {});
                                return;
                            }
                        };

                        /**
                         * Onclick trigger runs print popup depending on allowPrint state
                         * @method setPrint
                         */
                        $scope.setPrint = function () {
                            var printData    = [];
                            if ($scope.allowPrint && $scope.details && ($scope.details.length || Object.keys($scope.details).length)) {
                                if ($scope.details.template) {
                                    $scope.details.amountString = $scope.details.amount;
                                    $scope.details.commissionString = $scope.details.commission;
                                    $scope.details.amountWithCommissionString = $scope.details.amount + $scope.details.commission;
                                    $scope.setPrintTemplate($scope, $scope.initTemplate);
                                }
                            } else {

                                if ($scope.callback && typeof $scope.callback === 'function') {
                                    /* Case we need to get custom data source */
                                    $scope.preloader = true;
                                    $scope.callback(
                                        $scope.callbackparams,
                                        {scope: $scope, cardType: $scope.cardType},
                                        function (error, details, params) {
                                            if (error) {
                                                $scope.preloader = false;
                                                return;
                                            }
                                            if (details.data) {
                                                params.scope.details = details.data;

                                                if (details.data.date) {
                                                    details.data.date = parseDate(details.data.date);
                                                }

                                                details.data.amountString = details.data.amount;
                                                details.data.commissionString = details.data.commission;
                                                details.data.amountWithCommissionString = details.data.amount + details.data.commission;
                                                return verifyTemplate(printData, details, params, Localization);
                                            } else {
                                                $scope.preloader = false;
                                                return;
                                            }
                                        }
                                    );
                                }
                            }
                        };

                        $scope.$watch('datacontroller.isPaid', function (isPaid) {
                            if (isPaid) {
                                disablePrediction($scope);
                            }
                        });

                        /* predispatch Onclick event */
                        if ($scope.callback && typeof $scope.callback === 'function') {
                            $scope.allowPrint = false;
                        } else if ($scope.data && ($scope.data.length || Object.keys($scope.data).length)) {
                            $scope.details    = $scope.data;
                            $scope.allowPrint = true;
                        }
                    }
                ],
                link: function (scope, element, attr) {}
            };
        }
    ]);

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/paymentStatus/directives/printTemplate.directive.js
 ** module id = 208
 ** module chunks = 1
 **/